/*
  Length (1D)
*/
export const mmToInches = (mmValue) => mmValue / 25.4;
/*
  Area (2D)
*/
export const acresToFt = (acres) => acres * 43560;
// specifically for *square* meters to *square* feet
export const metersToFt = (areaInMeters) => areaInMeters * 10.764;
/*
  Volume (3D)
*/
export const cubicFtToGallon = (cubicFeet) => Math.round(cubicFeet * 7.481);
export const gallonsToAcreFeet = (gallons) => {
    return gallons / 325900.0;
};
export const gallonsToPersonYears = (gallons) => {
    return gallons / 17155.0;
};
//# sourceMappingURL=units.js.map